import { isStr } from './is-type-of';

const getJwtExpiration = (token) => {
  if (!isStr(token)) return null;

  try {
    const payloadBase64 = token.split('.')[1];
    const decodedPayload = JSON.parse(atob(payloadBase64));
    // `exp` is a UNIX timestamp in seconds
    return decodedPayload.exp;
  } catch (e) {
    console.error('Invalid JWT', e);
    return null;
  }
};

export const isJwtExpired = (token) => {
  const exp = getJwtExpiration(token);
  if (!exp) return true;

  return Date.now() > exp * 1000;
};
